/* eslint-disable */
import config from "@/config/index";
import { reject } from "lodash";
import api from '../../utils/axios-util';
import * as mutation_type from "../mutation-types";
const state = config.userManagement;
import auth0Variables from '../../utils/auth0-variables';
import { encoding, decoding } from '../../utils/EncodeDecode'
import { offset } from "highcharts";
const auth0Config = auth0Variables();
const common_api_url = auth0Config.common_api_url;

var getters = {
    usersdata: state => state.userManagement.usersdata,
    UserType: state => state.userManagement.UserType,
    userManagementFilter: state => state.userManagement.filter,
    QueueList: state => state.userManagement.QueueList,
    Createqueue: state => state.userManagement.Createqueue,
    AssignQueueList: state => state.userManagement.AssignQueueList
}
const mutations = {
    [mutation_type.userManagement]: (state, response) => {
        let usersdata = response.data.data;
        if (usersdata !== undefined) {
            usersdata = usersdata.map(userdata => {
                userdata.selectedroles = userdata.roles.map(role => {
                    return role.id;
                })
                return userdata;
            });
            state.userManagement.usersdata = usersdata;
        } else {
            state.userManagement.usersdata = [];
        }
    },
    [mutation_type.Createqueue]: (state, response) => {
        state.userManagement.Createqueue = response;
    },
    [mutation_type.UserType]: (state, response) => {
        state.userManagement.UserType = response;
    },
    [mutation_type.QueueList]: (state, response) => {
        state.userManagement.QueueList = response.data.data;
    },
    filter_userId: (state, response) => {
        state.userManagement.filter.UserId = response.user_id;
    },
    filter_Role: (state, response) => {
        state.userManagement.filter.Role = response.role;
    },
    filter_EmailId: (state, response) => {
        state.userManagement.filter.EmailId = response.user_email;
    },
    filter_MobileNumber: (state, response) => {
        state.userManagement.filter.MobileNumber = response.user_phone_number;
    }
};
const actions = {
    userManagement: ({ commit }, payload) => {
        let Filterpayload = {
            role: ["Agent"],
            offset:"0"
        }
        let payload_data=encoding(Filterpayload)
        
        return new Promise((resolve, reject) => {
            try {
                api.get(`${common_api_url}/tenantUser?offset=${payload_data.offset}&role=${payload_data.role}`).then(response => {
                    response.data.data = decoding(response.data.data)
                    
                    commit(mutation_type.userManagement, response);
                    resolve(response);
                }).catch(function(error) {
                    reject(error);
                });
            } catch (error) {
                reject(error);
            }
        })
    },
    filteruserManagement: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                let phno = state.userManagement.filter.MobileNumber != "" ? state.userManagement.filter.MobileNumber : 0;
                api.get(`${common_api_url}/tenantUser?user_email=${state.userManagement.filter.EmailId}&user_phone_number=${phno}&user_id=${state.userManagement.filter.UserId}&role=${state.userManagement.filter.Role}`).then(response => {
                    var userManagement_response = response;
                    commit(mutation_type.userManagement, userManagement_response);
                    resolve(response);
                }).catch(function(error) {
                    reject(error);
                });
            } catch (error) {
                reject(error);
            }
        })
    },
    UserType: ({ commit }) => {
        try {
            api.get(`${common_api_url}/roles`).then(response => {
                var UserType_response = response.data.data;
                var UserType_response = UserType_response.map(res => {
                    return { id: res.id, name: res.name };
                })
                commit(mutation_type.UserType, UserType_response);
            }).catch(function(error) {

            })
        } catch (error) {

        }
    },
    QueueList: ({ commit }) => {
        return new Promise((resolve, ) => {
            try {
                api.get(`${common_api_url}/queue`)
                    .then(response => {
                        var QueueList_response = response;
                        commit(mutation_type.QueueList, QueueList_response);
                        resolve(response);
                    }).catch(function(error) {
                        reject(error);
                    });
            } catch (error) {

            }
        })
    },
    getUserQueue: ({}, payload) => {
        return new Promise((resolve, reject) => {
            try {
                api.get(`${common_api_url}/queue/users?name=${payload}`).then(response => {
                    if (response.status == 200) {
                        let res = response.data.data[0];
                        res.queue = res.queue.split(",").map((val) => { return val.trim() });
                        resolve(res);
                    } else if (response.status == 204) {
                        var d = {
                            id: '',
                            name: payload,
                            interface: "",
                            user_rank: 0,
                            queue: []
                        };
                        resolve(d);
                    } else {
                        let error = "Invalid Response";
                        reject(error);
                    }
                }).catch(function(error) {
                    reject(error);
                });
            } catch (error) {

            }
        })
    },
    createQueueUser: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            var Queue_assign = {
                "name": payload.name,
                "interface": payload.interface,
                "user_rank": payload.user_rank,
                "queue": payload.queue
            }
            api.post(`${common_api_url}/queue/user/assign`, Queue_assign).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error);
            })
        })
    },
    DeleteQueueUser: ({}, payload) => {
        return new Promise((resolve, reject) => {
            api.delete(`${common_api_url}/queue/user/${payload}`).then(response => {
                if (response.status == 200) {
                    resolve(response);
                } else {
                    reject('Error');
                }
            }).catch(error => {
                reject(error);
            })
        })
    },
    UpdateQueueUser: ({}, payload) => {
        var updateItem = {
            "name": payload.name,
            "interface": payload.interface,
            "user_rank": payload.user_rank,
            "queue": payload.queue
        }
        return new Promise((resolve, reject) => {
            api.put(`${common_api_url}/queue/user/${payload.id}`, updateItem).then(response => {
                resolve(response);
            }).catch(function update(error) {
                reject(error.response);
            })
        })
    },
    editedItem: ({}, payload) => {
        var payloads = {
            "user_id": payload.user_id,
            "name": payload.name,
            "user_email": payload.user_email,
            "user_phone_number": payload.user_phone_number,
            "roles": [payload.roles],
            "project_id": payload.project_id,
            "status": payload.status.value
        }
        payloads.groups = payload.groups;
        return new Promise((resolve, reject) => {
            const dat = { data: payloads };
        
            api.put(`${common_api_url}/projectUsers?id=${payload.id}&user_email=${payload.user_email}`, dat)
                .then(response => {
                    // On success of the first API call, call the second API
                    const userActionPayload = {
                        "agent":payload.user_email,
                        "action":"edit",
                        "additional_info":payloads
                    }
        
                    return api.post(`/userAction`, userActionPayload)
                        .then(userActionResponse => {
                            resolve(response);
                        })
                        .catch(userActionError => {
                            reject(userActionError.response);
                        });
                })
                .catch(error => {
                    reject(error.response);
                });
        });
        
    },
    newlyUser: ({}, payload) => {
        var userdata = {
            "project": {
                "id": localStorage.getItem("projectId")
            },
            "user": [{
                "user_email": payload.user_email,
                "user_phone_number": payload.user_phone_number,
                "user_id": payload.user_id,
                "name": payload.name,
                "auth": {
                    "password": payload.password,
                    "roles": [payload.roles]
                }
            }]
        }


        userdata.user[0].groups = payload.groups;
        return new Promise((resolve, reject) => {
            api.post(`${common_api_url}/projectUsers`, userdata).then(response => {
                    resolve(response);
                })
                .catch(function(error) {
                    reject(error.response);
                })
        })
    },
    DeleteRow: ({}, payload) => {
        var deleted_id = {
            "id": payload.id
        }
        var deletes = { data: deleted_id }
        return new Promise((resolve) => {
            api.delete(`${common_api_url}/deleteUser`, deletes).then(response => {
                resolve(response);
            })
        })
    },
    EditPassword: ({}, payload) => {
        try {
            return new Promise((resolve, reject) => {
                api
                    .put(`${common_api_url}/userPassword?id=${payload.id}&user_email=${payload.user_email}`, { "password": payload.ConfirmPassword })
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(function(error) {
                        reject(error.response.data);
                    })
            })
        } catch (err) {
            reject(err);
        }
    }
};
export default {
    state,
    getters,
    mutations,
    actions
}